import Bugsnag from '@bugsnag/js'

Bugsnag.start({
  apiKey: bugsnag_api_key,
  appVersion: '1.0.0',  
})

export default Bugsnag
